module.exports = __webpack_public_path__ + "static/media/parallax-twitter-bg.31481999.jpg";